var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.item.isNew)?_c('span',{staticClass:"label label-primary"},[_vm._v("New")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }